import { type Dayjs, isDayjs } from 'dayjs'
import { isNotNullish, isNullish } from 'effect/Predicate'

import type { Operator } from '../syntax/expression_ast.ts'

// eslint-disable-next-line sonarjs/function-return-type
export function callOperator(operator: Operator, left: unknown, right: unknown) {
  if (typeof left === 'number' && typeof right === 'number') {
    return callOperatorForNumber(operator, left, right)
  }
  if (isDayjs(left) && isDayjs(right)) {
    return callOperatorForDate(operator, left, right)
  }

  return callOperatorForAny(operator, left, right)
}

function callOperatorForDate(operator: Operator, left: Dayjs, right: Dayjs) {
  switch (operator) {
    case '+': {
      throw new Error(`演算子${operator}はdate,dateに対して定義されていません。`)
    }
    case '-': {
      throw new Error(`演算子${operator}はdate,dateに対して定義されていません。`)
    }
    case '*': {
      throw new Error(`演算子${operator}はdate,dateに対して定義されていません。`)
    }
    case '/': {
      throw new Error(`演算子${operator}はdate,dateに対して定義されていません。`)
    }
    case '>=': {
      return left.isAfter(right) || left.isSame(right)
    }
    case '<=': {
      return left.isBefore(right) || left.isSame(right)
    }
    case '>': {
      return left.isAfter(right)
    }
    case '<': {
      return left.isBefore(right)
    }
    case '=': {
      return left.isSame(right)
    }
    case '!=': {
      return !left.isSame(right)
    }
    case '&&': {
      return true
    }
    case '||': {
      return true
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    default: {
      // eslint-disable-next-line sonarjs/no-dead-store,sonarjs/no-unused-vars
      const x: never = operator
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`演算子${operator as unknown}は${typeof left},${typeof right}に対して定義されていません。`)
    }
  }
}

// eslint-disable-next-line sonarjs/function-return-type
function callOperatorForNumber(operator: Operator, left: number, right: number) {
  switch (operator) {
    case '+': {
      return left + right
    }
    case '-': {
      return left - right
    }
    case '*': {
      return left * right
    }
    case '/': {
      return left / right
    }
    case '>=': {
      return left >= right
    }
    case '<=': {
      return left <= right
    }
    case '>': {
      return left > right
    }
    case '<': {
      return left < right
    }
    case '=': {
      return left === right
    }
    case '!=': {
      return left !== right
    }
    case '&&': {
      return true
    }
    case '||': {
      return true
    }
    // eslint-disable-next-line @typescript-eslint/switch-exhaustiveness-check
    default: {
      // eslint-disable-next-line sonarjs/no-dead-store,sonarjs/no-unused-vars
      const x: never = operator
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`演算子${operator as unknown}は${typeof left},${typeof right}に対して定義されていません。`)
    }
  }
}

function callOperatorForAny(operator: Operator, left: unknown, right: unknown) {
  switch (operator) {
    case '=': {
      return (left ?? false) === (right ?? false)
    }
    case '!=': {
      return (left ?? false) !== (right ?? false)
    }
    case '&&': {
      return left !== false && isNotNullish(left) && right !== false && isNotNullish(right)
    }
    case '||': {
      return (left !== false && isNotNullish(left)) || (right !== false && isNotNullish(right))
    }
    case '>=':
    case '<=':
    case '>':
    case '<': {
      // 比較演算子でnull値が含まれる場合はfalseを返し、compileをエラーとして終わらせない
      if (isNullish(left) || isNullish(right)) {
        return false
      }
      throw new Error(
        `演算子${operator}は${typeof left},${typeof right}に対して定義されていません。${JSON.stringify(
          left,
        )}, ${JSON.stringify(right)}`,
      )
    }
    default: {
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`演算子${operator as unknown}は${typeof left},${typeof right}に対して定義されていません。`)
    }
  }
}
